import React, { useState } from "react";
import { FantasyPlayer } from "../../models/FantasyPlayer";
import useLocalStorage from "use-local-storage";
import ReadOnlyPlayerSlot from "./ReadOnlyPlayerSlotProps";
import PlayerTeamHistoryComponent from "../../components/PlayerTeamHistoryComponent";

interface CustomTeam {
  teamId: string;
  teamName: string;
  teamLogo: string;
  players?: FantasyPlayer[];
  avgElo?: number;
}

interface ReadOnlyTeamSlotProps {
  team: CustomTeam;
}

const ReadOnlyTeamSlot: React.FC<ReadOnlyTeamSlotProps> = ({ team }) => {
  const [isDark] = useLocalStorage<boolean>('isDark', false);
  const [showHistory, setShowHistory] = useState<boolean>(false);

  const toggleHistory = () => {
    setShowHistory(prev => !prev);
  };

  return (
    <div className={`card mb-3 ${isDark ? 'bg-dark text-white' : ''}`}>
      <div className={`card-header d-flex align-items-center justify-content-between ${isDark ? 'border-secondary' : ''}`}>
        <div className="d-flex align-items-center">
          <img
            src={team.teamLogo}
            alt="Logo"
            style={{ width: "50px", height: "50px", objectFit: "contain" }}
            loading="lazy"
          />
          <span className="ms-3 fs-5">{team.teamName}</span>
          {team.avgElo && (
            <span className="badge bg-secondary ms-3">AVG ELO: {team.avgElo}</span>
          )}
        </div>
        
        {/* View History button in top right */}
        {team.players && team.players.length > 0 && (
          <button 
            className={`btn btn-sm ${isDark ? 'btn-outline-light' : 'btn-outline-primary'}`}
            onClick={toggleHistory}
          >
            {showHistory ? 'Hide History' : 'View History'}
          </button>
        )}
      </div>
      
      <div className="card-body">
        <div className="row">
          {team.players && team.players.length > 0 ? (
            team.players.map((player: FantasyPlayer, index: number) => (
              <div className="col-lg-2 col-md-4 col-sm-6 mb-4" key={index}>
                <ReadOnlyPlayerSlot player={player} />
                
                {/* History appears directly under each player card */}
                {showHistory && (
                  <div className="mt-2" style={{ maxWidth: "220px" }}>
                    <PlayerTeamHistoryComponent 
                      steamId={player.account.steamID} 
                      isDark={isDark}
                      compact={true}
                    />
                  </div>
                )}
              </div>
            ))
          ) : (
            <p className={isDark ? 'text-white' : ''}>No players available</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReadOnlyTeamSlot;